/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {Logger}        from '@/util/logger';
import {fromMySQLDate} from '@/util/util';
import {SimulationJob} from './simulation.job';

/**
 *
 * @class BatchSimJob
 *
 * @brief batch jobs are a proxy for teh batch that runs inside the scalable work engine (SWE); basically
 * the batch of simulations running in Cloud Run.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2022
 *
 */
export class BatchSimJob extends SimulationJob {

  /** the SWE batch id */
  public batchId: string       = '';

  /** the SWE result id */
  public resultId: string      = '';

  /** the Google storage prefix */
  public googleId: string      = '';

  /** most recent summary of progress / actions */
  public summary: string       = '';

  /** last known result details */
  public result: any           = null;

  /** the most recent error */
  public lastError: string     = '';

  /** the current (known) job progress */
  public progress: number      = 0;

  public totals: {
        total: number,
      running: number,
       failed: number,
    completed: number,
    remaining: number
  }                            = {
        total: 0,
      running: 0,
       failed: 0,
    completed: 0,
    remaining: 0
  }

  /** JSON object with various extra details */
  public meta: any             = null;

  /** when the batch is completed, we total up the cell KPI to one big KPI blob */
  public kpi: string           = '';

  /** standard constructor */
  public constructor(init?: Partial<BatchSimJob>) {

    super(init);

    Object.assign(this, init);
  }

  /**
   * all implementations must return a simplified version of themselves, that is appropriate for use
   * with JSON.stringify().
   */
  toJSON(init?: any): any  {

    return super.toJSON({

      batchid:   this.batchId,
      resultid:  this.resultId,
      googleid:  this.googleId,
      summary:   this.summary,
      lasterror: this.lastError,
      progress:  this.progress,
      total:     this.totals.total,
      running:   this.totals.running,
      failed:    this.totals.failed,
      completed: this.totals.completed,
      remaining: this.totals.remaining,

      meta:      JSON.stringify(this.meta),

      kpi:       this.kpi

    });
  }

  /**
   * all implementations must be able to recover themselves from the given object which was
   * deserialized via JSON.parse().
   */
  fromJSON(json: any) {

    super.fromJSON(json);

    this.batchId          = json.batchid;
    this.resultId         = json.resultid;
    this.googleId         = json.googleid;
    this.summary          = json.summary;
    this.lastError        = json.lasterror;
    this.progress         = json.progress;
    this.totals.total     = json.total;
    this.totals.running   = json.running;
    this.totals.failed    = json.failed;
    this.totals.completed = json.completed;
    this.totals.remaining = json.remaining;

    this.meta             = JSON.parse(json.meta);

    this.kpi              = json.kpi;

    if (typeof this.progress === 'undefined') {

      this.progress = 0;
    }
  }

}
